import { Route } from '@angular/router';
import { pagePermissionActivate } from '../page-permission';

export const purchaseRoutes: Route = {
    path: 'purchase',
    data: { title: 'purchase' },
    children: [
        { path: '', pathMatch: 'full', redirectTo: 'subscription' },
        {
            path: 'subscription-plan',
            loadComponent: () =>
                import('./subscription-plan/subscription-plan.component').then((m) => m.SubscriptionPlanComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'subscription-plan' },
        },
        {
            path: 'product-list',
            loadComponent: () => import('./product-list/product-list.component').then((m) => m.ProductListComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Product list' },
        },
        {
            path: 'subscription',
            loadComponent: () => import('./subscription/subscription.component').then((m) => m.SubscriptionComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Subscription' },
        },
        {
            path: 'subscription-plantation',
            loadComponent: () =>
                import('./subscription-plantation/subscription-plantation.component').then(
                    (m) => m.SubscriptionPlantationComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Subscription plantation' },
        },
        {
            path: 'subscription-plantation-history',
            loadComponent: () =>
                import('./subscription-plantation-history/subscription-plantation-history.component').then(
                    (m) => m.SubscriptionPlantationHistoryComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Subscription plantation history' },
        },
        {
            path: 'subscription-status',
            loadComponent: () =>
                import('./subscription-status/subscription-status.component').then((m) => m.SubscriptionStatusComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Subscription status' },
        },
        {
            path: 'subscription-transaction',
            loadComponent: () =>
                import('./subscription-transaction/subscription-transaction.component').then(
                    (m) => m.SubscriptionTransactionComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Subscription transaction' },
        },
        {
            path: 'transaction',
            loadComponent: () => import('./transaction/transaction.component').then((m) => m.TransactionComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Transaction' },
        },
    ],
};
